export default {
    INVALID_DATA: 'Hindi wasto ang paggawa, kailangan mo magsumite ng ulat ng bug.',
    INVALID_ITEM: 'Hindi wasto ang item na iyong napili.',
    INVALID_ITEMS: 'Mali ang item mo para gawin ito.',
    SELECT_ITEM: 'Pumili ka ng item para gawin ito.',
    FAILED_CRAFT: 'Nabigo kang gumawa. {{failedText}}',
    FAILED_CRAFT_ONE: ' You have failed to craft the item.'
} as const;
